import ControlSelectedIcon from '@material-ui/icons/BusinessCenter'
import ControlIcon from '@material-ui/icons/BusinessCenterOutlined'
import ProjectsIcon from '@material-ui/icons/FolderOutlined'
import ProjectsSelectedIcon from '@material-ui/icons/FolderRounded'
import HomeIcon from '@material-ui/icons/HomeOutlined'
import HomeSelectedIcon from '@material-ui/icons/HomeRounded'
import ShoppingCart from '@material-ui/icons/ShoppingCart'
import ShoppingCartOutlined from '@material-ui/icons/ShoppingCartOutlined'
import { PaymentsIcon, StoreFrontIcon } from 'opensolar-ui'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useFeatureFlag } from 'util/featureFlags'

const useBottomNavigationIcons = () => {
  const isNav3Enabled = useFeatureFlag('nav_3', 'on')
  const zone = useSelector((state: any) => state.zone)

  return useCallback(
    (zoneValue) => {
      const isZoneSelected = zoneValue === zone && !isNav3Enabled

      switch (true) {
        case zoneValue === 'home':
          return isZoneSelected ? <HomeSelectedIcon /> : <HomeIcon />

        case zoneValue === 'crm':
          return isZoneSelected ? <ProjectsSelectedIcon /> : <ProjectsIcon />

        case zoneValue === 'control':
          return isZoneSelected ? <ControlSelectedIcon /> : <ControlIcon />

        case zoneValue === 'shop':
          return isZoneSelected ? <ShoppingCart /> : <ShoppingCartOutlined />

        case zoneValue === 'expo':
          return <StoreFrontIcon />

        case zoneValue === 'cashflow':
          return <PaymentsIcon />

        default:
          break
      }
    },
    [isNav3Enabled, zone]
  )
}

export default useBottomNavigationIcons
